import { FC, useEffect, useState } from "react";
import { HeaderLeft } from "../../components/HeaderLeft/HeaderLeft";
import { IModelInfo, ModelInfo } from "../../components/ModelInfo/ModelInfo";
import styles from "./ModelPanel.module.scss";
import { useAppSelector } from "../../services/hooks";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../helpers/routes";
import { MenuTabs } from "../../components/MenuTabs/MenuTabs";
import Loader from "../../components/Loader/Loader";

export const ModelPanel: FC = () => {
  const [userData, setUserData] = useState<IModelInfo | null>(null);
  const { user, loading } = useAppSelector((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      if (user.type === "client") {
        navigate(ROUTES.profile);
        return;
      }
      if (user.type === "admin") {
        navigate(ROUTES.admin);
        return;
      }
      setUserData({
        name: user.username,
        photo: user?.profileAvatar?.avatarUrl,
        verification: user.isVerify,
        dataImage: user.gallery,
      });
    }
  }, [navigate, user]);

  if (loading || !userData)
    return (
      <div className="loader-container">
        <Loader color="#ac2386" size={60} borderWidth={5} />
      </div>
    );

  return (
    <div className={styles.ModelPanel}>
      <MenuTabs type="model" />
      <ModelInfo {...userData} />
    </div>
  );
};
